import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GoalsModel } from 'src/app/models/goals.model';

@Component({
  selector: 'app-goals-update-modal',
  templateUrl: './goals-update-modal.component.html',
  styleUrls: ['./goals-update-modal.component.scss']
})
export class GoalsUpdateModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GoalsUpdateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GoalsModel
  ) { }


  ngOnInit(): void {
  }

  onConfirmUpdate(formValues: any) {
    this.dialogRef.close({
      formValues: formValues});
  }

  onCancelClick() {
    this.dialogRef.close();
  }

}
